import { TroubleshootingStepName } from '../../../../modules/troubleshooting/constants';
import { getStepName } from '../../../../modules/troubleshooting/selectors';
import AbstractTrack from '../abstract.track';
const initialSteps = {
    initiated: undefined,
    video_refreshed: undefined,
    call_restarted: undefined,
    problem_resolved: undefined,
};
export default class TroubleshootingInitiatedTrack extends AbstractTrack {
    constructor() {
        super(...arguments);
        this.eventNameSegment = 'Troubleshooting initiated';
    }
    start() {
        let steps = {
            ...initialSteps,
        };
        let previousStep;
        const onTroubleshootingStepChange = (step) => {
            switch (step) {
                case TroubleshootingStepName.Initial:
                    steps.initiated = true;
                    break;
                case TroubleshootingStepName.VideoRefreshed:
                    steps.video_refreshed = true;
                    break;
                case TroubleshootingStepName.CallRestarted:
                    steps.call_restarted = true;
                    break;
                case TroubleshootingStepName.ProblemResolved:
                    steps.problem_resolved = true;
                    break;
                case TroubleshootingStepName.NothingHelped:
                    steps.problem_resolved = false;
                    break;
                case null:
                    if (steps.initiated)
                        this.trackSegment({ steps });
                    steps = { ...initialSteps };
                    break;
            }
        };
        const onStateChange = () => {
            const state = this.$ngRedux.getState();
            const step = getStepName(state);
            if (previousStep !== step) {
                onTroubleshootingStepChange(step);
            }
            previousStep = step;
        };
        this.$ngRedux.subscribe(onStateChange);
    }
}
